/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AlertController } from '@ionic/angular';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '@shared/utils/util';
import { Platform } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { LocationService } from '@shared/services/location.service';
import { UserService } from '@shared/services/user.service';
import { UserModel } from '@shared/models/user.model';
import { HttpClient } from '@angular/common/http';
import { FcmService } from '@shared/services/fcm.service';
import { GoogleAuth } from '@southdevs/capacitor-google-auth';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { SignupWithEmailPage } from '../signup-with-email/signup-with-email.page';
import { ActivatedRoute, Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { MatchService } from 'src/app/services/match.service';
import { environment, webVersion } from 'src/environments/environment';
import { FacebookUser } from '@shared/interfaces/facebook-user-interface';
import { FacebookService } from '@shared/services/facebook.service';
import { Capacitor } from '@capacitor/core';
import { GoogleWebAuthService } from 'src/app/services/google-web-auth.service';

@Component({
  selector: 'app-login-shared',
  templateUrl: './login-shared.page.html',
  styleUrls: ['./login-shared.page.scss'],
  providers: [UtilService, UserService, NavParams]
})
export class LoginSharedPage implements OnInit {

  public isNative: boolean = this.util.isNative();
  public isIos: boolean = true;
  public deviceInfo: any;
  public userData: any = {}; // Initialize with an empty object
  public imageFB: string = '';
  public processingAppleSignin: boolean = false;
  public processingGoogleSignin: boolean = false;
  public processingFacebookSignin: boolean = false;
  public userLoggedIn: boolean = false;
  public submitAttempt: boolean = false;
  public referralUserId: string = "";
  public otherUserData: any;
  private referralPhotoFallbackUrls: string[] = [];
  private referralPhotoFallbackIndex = 0;
  private hasReloaded = false;

  myForm = new FormGroup({
    emailControl: new FormControl('', Validators.compose([Validators.maxLength(50), Validators.email, Validators.required])),
    userpassControl: new FormControl('', Validators.compose([Validators.maxLength(15), Validators.required])),
  });

  public myImageFB: any;

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private facebookService: FacebookService,
    public loadingCtrl: LoadingController,
    private translate: TranslateService,
    private util: UtilService,
    public platform: Platform,
    private locationService: LocationService,
    private userService: UserService,
    private userModel: UserModel,
    private http: HttpClient,
    private fcm: FcmService,
    private route: ActivatedRoute,
    public toastCtrl: ToastController,
    private analytics: AnalyticsService,
    public navParams: NavParams,
    public router: Router,
    private matchService: MatchService,
    private googleWebAuth: GoogleWebAuthService
  ) {
    platform.ready().then(() => {
      // referralUserId pode vir do modal (componentProps) ou da rota (query params)
      const fromNavParams = this.navParams.get('referralUserId') as string | null;
      if (fromNavParams) {
        this.referralUserId = fromNavParams;
        void this.userService.markReferralJoinPending('friend');
        this.getInfosUserById();
      }
      this.route.queryParams.subscribe(params => {
        const fromQuery = params['referralUserId'] ?? params['referralId'] ?? '';
        if (fromQuery) {
          this.referralUserId = fromQuery;
          void this.userService.markReferralJoinPending('friend');
          this.getInfosUserById();
        }
      });

      const isModal = this.navParams.get('isModal');
      if (isModal != null && isModal == "true" && !this.hasReloaded) {
        this.hasReloaded = true;
      }

      this.util.initTranslate()
      this.isNative = this.util.isNative()
      this.isIos = !platform.is('android');

      console.log('this.isIos:' + this.isIos);
      console.log('this.isNative:' + this.isNative);
      console.log('ipad:' + platform.is('ipad'));

      console.log('_platforms:' + platform.platforms());


      console.log('UtilService.loggedOut:' + UtilService.loggedOut);


      if (!UtilService.loggedOut) {
        Preferences.get({ key: 'USER_DATA' }).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          console.log('login constructor userdata: ' + val);
          if (val != null) {
            this.modalCtrl.dismiss();
          }
        })
      }
    })

  }

  ngOnInit() {
    this.getDevice();
  }

  async ionViewDidEnter() {
    // WEB: pré-carrega o GIS para que o clique em "Entrar com Google" seja síncrono
    // (o gapi.auth2 legado do plugin foi desligado pelo Google).
    if (!Capacitor.isNativePlatform()) {
      this.googleWebAuth.preload(environment.googleAuth.web).catch((e) => console.warn('GIS preload:', e));
    }
    // Garantir referralUserId quando a página é aberta como modal (componentProps)
    const fromNavParams = this.navParams.get('referralUserId') as string | null;
    if (fromNavParams && !this.referralUserId) {
      this.referralUserId = fromNavParams;
      this.getInfosUserById();
    } else if (this.referralUserId && !this.otherUserData) {
      this.getInfosUserById();
    }
    const tabBar = document.getElementById('app-tab-bar');
    if (tabBar !== null) {
      tabBar.style.display = 'none';
    }

    console.log('ionViewDidEnter LoginPage');

    console.log('UserService.loggedOut:' + UserService.loggedOut);

    if (!UserService.loggedOut) {

      Preferences.get({ key: 'USER_DATA' }).then((val) => {
        val = val.value ? JSON.parse(val.value) : null;
        console.log('login ionViewDidEnter userdata: ' + val);

        if (val != null) {
          this.modalCtrl.dismiss();
        }
      })

    }

  }

  private loader = this.loadingCtrl.create({
    message: this.translate.instant('msgOneMomentPlease'),
  });

  private resolvePictureOid(value: any): string | null {
    if (!value) return null;
    if (typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value)) return value;
    if (value.$oid) return value.$oid;
    return null;
  }

  private resolvePublicProfilePhotoUrl(profile: any): string {
    this.referralPhotoFallbackUrls = [];
    this.referralPhotoFallbackIndex = 0;

    const firstPicId = this.resolvePictureOid(profile?.firstPic);
    if (firstPicId) {
      const primaryUrl = this.userService.getImageURL(firstPicId);
      const fallbackUrl = `${environment.mainServer.replace(/\/$/, '')}/soul/image/${firstPicId}`;
      this.referralPhotoFallbackUrls = [primaryUrl, fallbackUrl].filter(
        (value, index, arr) => !!value && arr.indexOf(value) === index
      );
      return this.referralPhotoFallbackUrls[0] ?? '';
    }

    // Fallback: some payloads provide picture0..picture8 instead of firstPic.
    const fallbackPicId = this.userService.getFirstAvailablePicture(profile);
    if (fallbackPicId) {
      const primaryUrl = this.userService.getImageURL(fallbackPicId);
      const fallbackUrl = `${environment.mainServer.replace(/\/$/, '')}/soul/image/${fallbackPicId}`;
      this.referralPhotoFallbackUrls = [primaryUrl, fallbackUrl].filter(
        (value, index, arr) => !!value && arr.indexOf(value) === index
      );
      return this.referralPhotoFallbackUrls[0] ?? '';
    }

    if (typeof profile?.firstPic === 'string' && profile.firstPic.length > 0) {
      return profile.firstPic;
    }
    return '';
  }

  onReferralProfileImageError() {
    if (!this.otherUserData || this.referralPhotoFallbackUrls.length === 0) {
      return;
    }
    const nextIndex = this.referralPhotoFallbackIndex + 1;
    if (nextIndex >= this.referralPhotoFallbackUrls.length) {
      this.otherUserData.firstPic = '';
      return;
    }
    this.referralPhotoFallbackIndex = nextIndex;
    this.otherUserData.firstPic = this.referralPhotoFallbackUrls[nextIndex];
  }


  getInfosUserById() {
    if (!this.referralUserId) return;
    void this.userService.markReferralJoinPending('friend');
    this.userService.viewProfilePublic(this.referralUserId).subscribe({
      next: (data) => {
        if (data != '{not ok}') {
          this.otherUserData = JSON.parse(data);
          this.otherUserData.firstPic = this.resolvePublicProfilePhotoUrl(this.otherUserData);
          const source = this.userService.resolveReferralSource(this.otherUserData);
          void this.userService.markReferralJoinPending(source);
        }
      },
      error: async (error) => {
        console.log('Upsert error: ' + JSON.stringify(error.toString()));
        (await this.loader).dismiss();
      }
    });

  }


  async getDevice() {
    const device = await Device.getInfo();
    if (this.util.isNative()) {
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: (await App.getInfo()).version,
      };

    } else {
      // Browser
      this.deviceInfo = {
        manufacturer: device.manufacturer,
        model: device.model,
        version: device.osVersion,
        platform: device.platform,
        uuid: (await Device.getId()).identifier,
        appVersion: webVersion
      }

    }
    this.userModel.device = this.deviceInfo
  }

  exit() {
    this.modalCtrl.dismiss();
  }

  async showModalAlert(message: string) {
    const alert = await this.alertCtrl.create({
      subHeader: message,
      buttons: [
        {
          text: 'OK',
          handler: () => { }
        }
      ]
    });

    await alert.present();
  }


  async showLoading(message: string) {
    const loading = await this.loadingCtrl.create({
      message: message,
      duration: 3000,
      // translucent: true,

      // backdropDismiss: true
    });

    loading.present();
  }
  loginWithPassword() {
    this.submitAttempt = true;
    if (!this.myForm.valid) {
      this.showModalAlert(this.translate.instant('fixHighlighted'));
    } else {
      this.showLoading(this.translate.instant('pleaseWait'));
    }
  }

  async goToForgotPasswordPage() {
    console.log("teste");

  }


  async openDefaultLogin() {
    UtilService.loggedOut = false;
    const modal = await this.modalCtrl.create({
      component: SignupWithEmailPage,
      componentProps: {
        referralUserId: this.referralUserId,
        isModal: true
      },
    });

    (await modal).onDidDismiss().then((val) => {
      if (val && val.data === "loggedIn") {
        this.modalCtrl.dismiss('loggedIn');
        UserService.loggedOut = false;
        this.router.navigateByUrl('/tabs/my-profile-display');
      }
    });
    modal.present();

  }


  async googleSignIn() {
    // WEB: o Google desligou o gapi.auth2 (usado pelo plugin na web). Usa Google Identity
    // Services (ID token flow) → googleIdToken, que é o que o backend valida. Nativo segue no plugin.
    if (!Capacitor.isNativePlatform()) {
      await this.googleSignInWeb();
      return;
    }

    let clientId: string = '';
    if (this.isIos) {
      clientId = environment.googleAuth.ios;
    } else {
      clientId = environment.googleAuth.android;
    }

    // Verificar se o clientId está definido
    if (!clientId) {
      throw new Error('Google Auth Client ID não encontrado');
    }

    this.processingGoogleSignin = true;
    try {
      await GoogleAuth.initialize({
        clientId: clientId,
        scopes: ['profile', 'email'],
        grantOfflineAccess: true,
      });
      const googleUser = await GoogleAuth.signIn({ scopes: ['profile', 'email'], serverClientId: environment.googleAuth.web });
      console.log('Google Authentication Result:', googleUser);

      // Handle authentication success
      if (googleUser.email == undefined || googleUser.email == null || googleUser.email == '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        return;
      }

      this.userData = {
        email: googleUser.email
      };

      if (this.referralUserId != null) {
        this.userData.referralUserId = this.referralUserId
      }

      if ((googleUser as any).googleUserId != null) {
        this.userData.googleUserId = (googleUser as any).googleUserId
      }
      if (googleUser.name != null) {
        this.userData.displayName = googleUser.name
      }
      if (googleUser.givenName != null) {
        this.userData.firstName = googleUser.givenName
      }
      if (googleUser.familyName != null) {
        this.userData.lastName = googleUser.familyName
      }
      if (googleUser.authentication?.refreshToken != null) {
        this.userData.googleRefreshToken = googleUser.authentication.refreshToken
      }
      if (googleUser.serverAuthCode != null) {
        this.userData.googleServerAuthCode = googleUser.serverAuthCode
      }

      if (googleUser.authentication?.accessToken != null) {
        this.userData.googleAccessToken = googleUser.authentication.accessToken
      }
      if (googleUser.authentication?.idToken != null) {
        this.userData.googleIdToken = googleUser.authentication.idToken
      }
      this.registerLoginEvents();
      this.saveProfile(null);
    } catch (error) {
      console.error('Google Authentication Error:', error);

      // Tratamento específico para diferentes tipos de erro
      let errorMessage = 'Erro desconhecido';

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      } else if (error && typeof error === 'object') {
        errorMessage = (error as any).message || JSON.stringify(error);
      }

      // Logs específicos para debugging em produção
      console.error('Google Auth Error Details:', {
        message: errorMessage,
        platform: Capacitor.isNativePlatform() ? (this.isIos ? 'iOS' : 'Android') : 'Web',
        clientId: environment.googleAuth[Capacitor.isNativePlatform() ? (this.isIos ? 'ios' : 'android') : 'web'],
        timestamp: new Date().toISOString()
      });

      this.processingGoogleSignin = false;
      this.showModalAlert(errorMessage);
    }
  }

  /**
   * Login Google na WEB via Google Identity Services (ID token flow).
   * Obtém o JWT (googleIdToken, validado no backend) e decodifica email/nome/sub para
   * manter o mesmo payload do fluxo nativo. Substitui o gapi.auth2 desligado pelo Google.
   */
  private async googleSignInWeb() {
    this.processingGoogleSignin = true;
    try {
      const idToken = await this.googleWebAuth.signInGetIdToken(environment.googleAuth.web);
      const claims = this.googleWebAuth.decodeIdToken(idToken);

      if (!claims || claims.email == null || claims.email === '') {
        this.showModalAlert(this.translate.instant('googleNoEmail'));
        this.processingGoogleSignin = false;
        return;
      }

      this.userData = { email: claims.email };
      if (this.referralUserId != null) {
        this.userData.referralUserId = this.referralUserId;
      }
      this.userData.googleIdToken = idToken;
      if (claims.sub != null) {
        this.userData.googleUserId = claims.sub;
      }
      if (claims.name != null) {
        this.userData.displayName = claims.name;
      }
      if (claims.given_name != null) {
        this.userData.firstName = claims.given_name;
      }
      if (claims.family_name != null) {
        this.userData.lastName = claims.family_name;
      }

      this.registerLoginEvents();
      this.saveProfile(null);
    } catch (error) {
      console.error('Google Authentication Error (web):', error);
      this.processingGoogleSignin = false;
    }
  }

  async loginWithFB() {
    this.processingFacebookSignin = true;
    const loading = await this.loadingCtrl.create({
      message: this.translate.instant('pleaseWait'),
      duration: 3000,
    });

    try {
      try {
        const { token, type } = await this.facebookService.login();
        const facebookUser: FacebookUser = await this.facebookService.getUserData(token, type);
        console.log('User Data:', facebookUser);
        if (token) {
          this.userData = facebookUser;
          this.userData.facebookAccessToken = token;
          this.userData.facebookLoginType = type;
          if (this.referralUserId != null) {
            this.userData.referralUserId = this.referralUserId
          }
          this.registerLoginEvents();
          this.saveProfile(facebookUser?.picture?.data?.url);
        } else {
          console.error('Falha no login do Facebook');
        }
      } catch (error) {
        console.error('Facebook Login Error:', error);
      }
    } catch (error) {
      console.error('Erro ao fazer login no Facebook:', error);
      this.processingFacebookSignin = false;
    }

    loading.present();
  }




  private async saveProfile(localPicture: any) {
    const lastLocation = await Preferences.get({ key: 'LAST_LOCATION' });
    let location = lastLocation?.value ? JSON.parse(lastLocation.value) : { type: 'Point', coordinates: [environment.locationDefault.coordinates[0], environment.locationDefault.coordinates[1]] };
    const teleportationLocation = this.locationService.getTeleportationLocation();
    if (teleportationLocation != null) {
      location = teleportationLocation;
    }

    // Retrieve and add FCM token to userData before sending to server
    console.log('=== Attempting to retrieve FCM token ===');
    let tokenValue = null;

    // Try Preferences first
    const fcmToken = await Preferences.get({ key: 'TOKEN' });
    if (fcmToken && fcmToken.value) {
      tokenValue = fcmToken.value;
      console.log('FCM token found in Preferences:', tokenValue);
    } else {
      console.log('No FCM token in Preferences, checking localStorage');
      // Fallback to localStorage
      const localToken = localStorage.getItem('TOKEN');
      if (localToken) {
        tokenValue = localToken;
        console.log('FCM token found in localStorage:', tokenValue);
      } else {
        console.log('No FCM token found in either storage location');
      }
    }

    if (tokenValue) {
      this.userData.token = tokenValue;
      console.log('FCM token successfully added to userData');
      console.log('userData object before upsertSoul:', JSON.stringify(this.userData));
    }

    this.userService
      .upsertSoul(this.userData, location, false, false, true)
      .subscribe(
        {
          next: async (data) => {
            if (data != '{not ok}') {
              this.userModel = JSON.parse(data);

              // Send image to Server
              const serverPicture = this.userData.picture0;

              if (localPicture != null && serverPicture == null) {
                this.userData = JSON.parse(data);
                this.http.get(localPicture, { responseType: 'blob' })
                  .subscribe(
                    {
                      next: (response: Blob) => {
                        const fileReader = new FileReader();
                        const zoneOriginalInstance = (fileReader as any).__zone_symbol__originalInstance;
                        const reader = zoneOriginalInstance || fileReader;

                        reader.onloadend = async () => {
                          const uploadImageFB = this.setFirstPicture();
                          if (uploadImageFB) {
                            this.imageFB = reader.result as string;
                            const filename: string = 'picture' + 0;
                            this.userService
                              .uploadImage64(this.imageFB, this.userModel, filename)
                              .subscribe(
                                {
                                  next: async (data) => {
                                    this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                                    this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                                    this.userModel.filename = { '$oid': data };
                                    this.userModel.picture0 = { '$oid': data };
                                    await this.storeUserLocally();
                                  },
                                  error: (_err) => {
                                    //alert('uploadImage error: ' + JSON.stringify(err));
                                  }
                                }
                              )
                          } else {
                            this.analytics.registerEvent(AnalyticsService.signUpComplete, true);
                            this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
                            await this.storeUserLocally();
                          }

                        }


                        reader.readAsDataURL(response);

                      },
                      error: (erro) => {
                        //alert("Usuário ou Senha inválido(s)!");
                        console.log(erro)
                      }
                    }
                  )
              } else {
                this.userData = JSON.parse(data);
                await this.storeUserLocally();
              }
            }
          },
          error: (erro) => {
            //alert("Usuário ou Senha inválido(s)!");
            console.log(erro)
            this.processingGoogleSignin = false;
            this.processingFacebookSignin = false;
            this.processingAppleSignin = false;
          }
        }
      )



  }

  setFirstPicture() {
    let picnum: number;
    let picCount: number = 0;
    const data2: any = this.userModel
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (data2[aPic]) {
        picCount++;
      }
    }
    if (picCount == 0) {
      return true;
    }
    return false
  }

  private async storeUserLocally() {
    // Mesmo usuário logando de novo: restaura teletransporte (backup primeiro, depois userData do servidor)
    await this.locationService.restoreTeleportationFromBackup(this.userModel);
    if (!this.locationService.getTeleportationLocation()) {
      await this.locationService.restoreTeleportationFromUserData(this.userModel);
    }
    const teleportLoc = this.locationService.getTeleportationLocation();
    if (teleportLoc) {
      this.userModel.location = teleportLoc;
      this.userModel.usingTeleportation = true;
    }

    // userModel é a fonte canônica pós-login (inclui hash, _id e mutações de upload de imagem).
    // Sincroniza userData e persiste USER_DATA numa única escrita atômica.
    this.userData = { ...this.userModel };
    console.log('Stored UserData = ' + JSON.stringify(this.userData));
    await Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) });

    console.log('Will set UserService.loggedOut to false. Current value: ' + UserService.loggedOut);
    UserService.loggedOut = false;
    this.processingGoogleSignin = false;
    this.processingFacebookSignin = false;
    this.processingAppleSignin = false;
    this.restartMatchService();
    localStorage.setItem('USER_LOGGED', 'true');
    await Preferences.set({ key: 'USER_LOGGED', value: 'true' });
    this.showWelcomeBackMsg();

    if (this.userData.interest2 != null) {
      this.router.navigateByUrl('/tabs/home');
    } else {
      this.router.navigateByUrl('/tabs/my-profile-display');
    }
  }

  registerLoginEvents() {
    // Your logic for registering login events
    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (this.userService.checkUserHasPicture(val)) {
        this.analytics.registerEvent(AnalyticsService.loginOrSignUpCompl, true);
        if (val.sign_up_compl_ok)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpComplOk, true);
        if (val.valuable_user_1d)
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable1d, true);
        if (val.valuable_user) {
          this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuable, true);
          if (val.gender2 === 'female')
            this.analytics.registerEvent(AnalyticsService.loginOrSignUpValuableWoman, true);
        }
      }
    })
  }

  showWelcomeBackMsg() {
    if (this.userModel.wasOnHibernate != null) {
      this.showModalAlert(this.translate.instant('welcomeBackFromHibernate'));
      delete this.userModel.wasOnHibernate;

      Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userModel) }).then(() => {
        console.log('login.showWelcomeBackMsg: saved user without the wasOnHibernate');
      });
    }
  }

  async presentToast(msg: string, dur: number) {
    const toast = this.toastCtrl.create({
      message: msg,
      duration: dur,
      buttons: [
        {
          text: this.translate.instant('close'),
          role: 'cancel',
        }
      ],

    });
    (await toast).present();
  }

  downloadImage(pathImg: any) {
    this.http.get(pathImg, { responseType: 'blob' })
      .subscribe(res => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.myImageFB = reader.result?.toString();

          const filename: string = 'picture' + 0;
          this.userService.uploadImage64(this.myImageFB, this.userData, filename).subscribe(
            data => {
              console.log('upload image succesful');
              console.log('data returned JSON.stringify: [' + JSON.stringify(data) + ']');
              this.userData[filename] = { '$oid': data };
              Preferences.set({ key: 'USER_DATA', value: JSON.stringify(this.userData) }).then(() => {
                console.log('userdata saved to Preferences with new location');
              });
            },
            err => {
              console.log('uploadImage error: ' + JSON.stringify(err));
            });
        };
        reader.readAsDataURL(res);
      });
  }

  private restartMatchService() {
    this.matchService.restartRefresh();
  }
  private createFileName(index: number) {
    return 'picture' + index + '.jpg';
  }
}
